<template>
  <v-navigation-drawer fixed right clipped app v-model="state" width="420">
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-avatar></v-avatar>
        <v-list-item-content>
          <v-list-item-title>{{contact.name}}</v-list-item-title>
          <v-list-item-subtitle>{{ "Phụ Huynh: " + contact.parentName}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-btn icon @click.stop="state = !state">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item>
    </template>

    <v-divider></v-divider>
    <v-tabs v-model="tab">
      <v-tab href="#tab-1">Ghi chú</v-tab>
      <v-tab href="#tab-2">Trải Nghiệm</v-tab>
      <v-tab href="#tab-3">Thông Tin</v-tab>
      <v-tab href="#tab-4">Đã Mua</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <contact-sale-tabs-item
        :key="1"
        :value="'tab-1'"
        :contact="contact"
        @cancel="cancel"
        @save="save"
      ></contact-sale-tabs-item>
      <contact-meeting-tabs-item
        :key="2"
        :value="'tab-2'"
        :contact="contact"
        @cancel="cancel"
        @save="save"
      ></contact-meeting-tabs-item>

      <contact-info-tabs-item
        :key="3"
        :value="'tab-3'"
        :contact="contact"
        @cancel="cancel"
        @save="save"
      ></contact-info-tabs-item>
      <contact-other-tabs-item
        :key="4"
        :value="'tab-4'"
        :contact="contact"
        @cancel="cancel"
        @save="save"
      ></contact-other-tabs-item>
    </v-tabs-items>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactSaleTabsItem from './ContactSaleTabsItem'
import ContactInfoTabsItem from './ContactInfoTabsItem'
import ContactMeetingTabsItem from './ContactMeetingTabsItem'
import ContactOtherTabsItem from './ContactOtherTabsItem'
import moment from 'moment'
export default {
  components: {
    ContactSaleTabsItem,
    ContactInfoTabsItem,
    ContactMeetingTabsItem,
    ContactOtherTabsItem
  },
  props: {
    draw: Boolean
  },
  data () {
    return {
      state: this.draw,
      tab: null
    }
  },
  computed: {
    ...mapGetters('contact', ['contact'])
  },
  methods: {
    ...mapActions('contact', ['updateContact']),
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    save (data) {
      data.handledDate = moment().toISOString()
      this.updateContact({ ...this.contact, ...data })
    },
    cancel () {
      this.state = false
    }
  },
  watch: {
    state (state) {
      this.$emit('onDrawerStateChange', state)
    },
    draw (draw) {
      this.state = draw
    }
  }
}
</script>
